import Reveal from "./Reveal";
import {
  Accordion,
  AccordionItem,
  AccordionTrigger,
  AccordionContent,
} from "@/components/ui/accordion";
import { FAQ } from "@/data/content";

const FAQSection = () => {
  return (
    <section
      id="faq"
      className="relative py-24 lg:py-32 max-w-4xl mx-auto px-6 lg:px-10"
      data-testid="faq-section"
    >
      <Reveal>
        <p className="font-mono-accent text-xs text-[#00D2D3] tracking-[0.25em] uppercase mb-4">
          Perguntas frequentes
        </p>
        <h2 className="font-outfit font-bold text-3xl sm:text-4xl text-white tracking-tight mb-12">
          Tudo que você precisa saber antes de começar.
        </h2>
      </Reveal>

      <Reveal delay={0.1}>
        <Accordion type="single" collapsible className="w-full">
          {FAQ.map((item, i) => (
            <AccordionItem
              value={`item-${i}`}
              key={i}
              className="border-white/10"
              data-testid={`faq-item-${i}`}
            >
              <AccordionTrigger
                className="text-left font-outfit text-base sm:text-lg text-white hover:text-[#00D2D3] hover:no-underline py-6"
                data-testid={`faq-trigger-${i}`}
              >
                {item.q}
              </AccordionTrigger>
              <AccordionContent
                className="text-white/55 font-manrope text-sm sm:text-base leading-relaxed"
                data-testid={`faq-content-${i}`}
              >
                {item.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </Reveal>
    </section>
  );
};

export default FAQSection;
